import React, { useState } from "react";
import _ from "lodash";
import { Form } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { CustomModal } from "../modal";
import { dispatchSnackbarError, dispatchSnackbarSuccess } from "../../utils/toaster";
import RadioGroupSelect from "../custom_form/radio";
import * as emailFinderActions from "../../containers/Integrations/store/actions/email-finder.actions";

export default function EmailFinderModel({ show, setShow, moduleName, moduleIds, onSuccess, isAllSelected, loadingStore }) {
    const [typeOfCondition, setTypeOfCondition] = useState("Find new only; ignore previously discovered ones.");
    const conditionOptions = [
        "Find new only; ignore previously discovered ones.",
        "Search for all, including both new and previously discovered ones."
    ];
    const dispatch = useDispatch();

    const onCancelAddEmailFinder = (e) => {
        e.stopPropagation();
        setShow(false);
    };

    const getConditionType = () => {
        if (typeOfCondition === conditionOptions[0]) {
            return "ONLY_NEW";
        } else if (typeOfCondition === conditionOptions[1]) {
            return "ALL";
        } else return "ALL";
    };

    const handleSaveClick = (e) => {
        e.stopPropagation();
        if (!typeOfCondition) {
            return dispatchSnackbarError("Please select a condition type");
        }

        if (isAllSelected) {
            const payload = {
                "type": "QUERY",
                "mode": moduleName,
                "condition": getConditionType(),
                "filter": {
                    filterId: loadingStore.filterId || null,
                    filter: [],
                    tags: Array.isArray(loadingStore.tagId) ? loadingStore.tagId : loadingStore.tagId ? [loadingStore.tagId] : [],
                    userId: null
                }
            };
            if (loadingStore.filter) {
                try {
                    const filter = JSON.parse(loadingStore.filter);
                    if (filter.andMatchConditions) {
                        payload.filter.filter = filter.andMatchConditions;
                    }
                } catch (err) {
                    console.log(err);
                    return dispatchSnackbarError("Error in filter");
                }
            }
            const payload2 = {
                from: moduleName,
                data: payload,
                filter: loadingStore
            }
            dispatch(emailFinderActions.createEmailFinderRequest(payload2, (data) => {
                if (data.status) {
                    dispatchSnackbarSuccess(data.message);
                } else {
                    dispatchSnackbarError(data.message);
                }
                setShow(false);
                onSuccess();
            }));
        } else {
            if (_.isEmpty(moduleIds)) {
                return dispatchSnackbarError("Please select at least one lead!");
            }
            if (moduleIds && moduleName) {
                const payload = {
                    "type": moduleIds.length === 1 ? "SINGLE" : "BULK",
                    "mode": moduleName,
                    "selectedIds": moduleIds,
                    "condition": getConditionType()
                };
                const payload2 = {
                    from: moduleName,
                    data: payload,
                    filter: loadingStore
                }
                dispatch(emailFinderActions.createEmailFinderRequest(payload2, (data) => {
                    if (data.status) {
                        dispatchSnackbarSuccess(data.message);
                    } else {
                        dispatchSnackbarError(data.message);
                    }
                    setShow(false);
                    onSuccess();
                }));
            }
        }
    };
    const AddEFinderModalProps = {
        showButtons: true,
        show: show,
        title: "Email Finder",
        loading: false,
        buttonText: "Find Email",
        handleClose: onCancelAddEmailFinder,
        handleAccept: handleSaveClick,
    };
    return (
        <CustomModal modalProps={AddEFinderModalProps}>
            <Form.Group className1="card p-5 mt-5 mb-0">
                <Form.Label>Conditions for Operations</Form.Label>
                <RadioGroupSelect apiKeyName={"condition"} setValue={(value, apiKyName) => setTypeOfCondition(value)} value={typeOfCondition} options={conditionOptions} isRow={false} />
            </Form.Group>
        </CustomModal>
    );
}
